module.exports = __webpack_public_path__ + "static/media/IMG_1243.eede4d24.jpg";